import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet, Button, Col, Row } from '_zari/core'

import { ZrSwal } from 'utils'

import * as FacturacionService from 'services/facturacion.service'
import * as FacturacionHistorialService from 'services/facturacionHistorial.service'
import * as GuiasVentaHistorialService from 'services/guiasVentaHistorial.service'

import * as FormGroups from './formGroups'
import * as Sections from './sections'
import { TiposDocumentoSunatConstant } from 'constants/index'

import ResumenGuias from 'partials/resumenGuias'

const portletBreadcrumbs = [{ name: 'Dar de Baja' }]

const ComprobantesElectronicosTab = () => {
  const __zariContext = React.useContext(ZariContext)

  const _idKardex = React.useRef('')

  const [mostrarKardexResumen, setMostrarKardexResumen] = React.useState(false)
  const [numeroDocumento, setNumeroDocumento] = React.useState('')
  const [anioDocumento, setAnioDocumento] = React.useState(new Date().getFullYear())
  const [serieDocumento, setSerieDocumento] = React.useState('')
  const [tipoDocumento, setTipoDocumento] = React.useState('')
  const [documentoData, setDocumentoData] = React.useState(null)

  const clickConsultarHandler = () => {
    if (!anioDocumento) {
      return
    }

    if (!numeroDocumento) {
      return
    }

    if (!serieDocumento) {
      return
    }

    if (tipoDocumento === TiposDocumentoSunatConstant.GUIA_REMISION_REMITENTE) {
      GuiasVentaHistorialService.verificarParaBaja({
        numeroDocumento,
        serieDocumento,
        tipoDocumento,
        anioDocumento
      })
        .then(({ data }) => {
          _idKardex.current = data._id
          setMostrarKardexResumen(true)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    } else {
      FacturacionService.verificarParaBaja({
        numeroDocumento,
        serieDocumento,
        tipoDocumento,
        anioDocumento
      })
        .then(({ data }) => {
          FacturacionService.obtenerxIdAsInfoBaja(data._id, anioDocumento)
            .then(({ data: data2 }) => {
              setDocumentoData(data2)
            })
            .catch(({ data: { error } }) => __zariContext.snack('error', error))
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    }
  }

  const enviarAOSEClick = () => {
    ZrSwal.showAlert({
      tipo: 'warning',
      mensaje: 'Desea dar de baja el documento indicado?',
      onSuccess: () => {
        if (tipoDocumento === TiposDocumentoSunatConstant.GUIA_REMISION_REMITENTE) {
          GuiasVentaHistorialService.darDeBajaxId(_idKardex.current)
            .then(({ data }) => {
              __zariContext.snack('success', 'El documento ha sido dado de baja')
              _idKardex.current = ''
              setMostrarKardexResumen(false)
              setNumeroDocumento('')
              setSerieDocumento('')
              setTipoDocumento('')
            })
            .catch(({ data: { error } }) => __zariContext.snack('error', error))
        } else {
          FacturacionHistorialService.darDeBajaxId(documentoData._id)
            .then(({ data }) => {
              __zariContext.snack('success', 'El documento ha sido dado de baja')
              setDocumentoData(null)
              _idKardex.current = ''
              setNumeroDocumento('')
              setSerieDocumento('')
              setTipoDocumento('')
            })
            .catch(({ data: { error } }) => __zariContext.snack('error', error))
        }
      },
      showCerrar: true
    })
  }

  const clickAnular = () => {
    ZrSwal.showAlert({
      tipo: 'warning',
      mensaje: 'Desea anular el documento indicado?',
      onSuccess: () => {
        if (tipoDocumento !== TiposDocumentoSunatConstant.GUIA_REMISION_REMITENTE) {
          FacturacionHistorialService.anularxId(documentoData._id)
            .then(({ data }) => {
              __zariContext.snack('success', 'El documento ha sido anulado.')
              setDocumentoData(null)
              _idKardex.current = ''
              setNumeroDocumento('')
              setSerieDocumento('')
              setTipoDocumento('')
            })
            .catch(({ data: { error } }) => __zariContext.snack('error', error))
        }
      },
      showCerrar: true
    })
  }

  return (
    <>
      <Portlet className='mb-3'>
        <Portlet.Header title='Dar de Baja' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          <Row>
            <Col md={12}>
              <Row>
                <Col md={2}>
                  <FormGroups.AnioDocumentoFormGroup
                    value={anioDocumento}
                    onChange={e => {
                      setDocumentoData(null)
                      setAnioDocumento(e.target.value)
                    }}
                  />
                </Col>
                <Col md={2}>
                  <FormGroups.TipoDocumentoFormGroup
                    value={tipoDocumento}
                    onChange={e => {
                      setDocumentoData(null)
                      setTipoDocumento(e.target.value)
                    }}
                  />
                </Col>
                <Col md={2}>
                  <FormGroups.SerieDocumentoFormGroup
                    value={serieDocumento}
                    onChange={e => {
                      setDocumentoData(null)
                      setSerieDocumento(e.target.value)
                    }}
                  />
                </Col>
                <Col md={2}>
                  <FormGroups.NumeroDocumentoFormGroup
                    value={numeroDocumento}
                    onChange={e => {
                      setDocumentoData(null)
                      setNumeroDocumento(e.target.value)
                    }}
                  />
                </Col>
                <Col md={2}>
                  <Button onClick={clickConsultarHandler}>Consultar</Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Portlet.Body>
      </Portlet>
      {documentoData && (
        <>
          <Sections.VistaDocumentoSection documentoData={documentoData} />
          {!documentoData.flagDadoDeBaja && !documentoData.flagAnulado && (
            <Row className='px-4'>
              <Col md={6}>
                <Button color='danger' block onClick={clickAnular} outline>
                  ANULAR
                </Button>
              </Col>
              <Col md={6}>
                <Button color='danger' block onClick={enviarAOSEClick}>
                  DAR DE BAJA
                </Button>
              </Col>
            </Row>
          )}
        </>
      )}
      {mostrarKardexResumen && (
        <>
          <Portlet className='mb-3'>
            <Portlet.Body>
              <ResumenGuias id={_idKardex.current} anio={anioDocumento} />
            </Portlet.Body>
          </Portlet>
          <Row className='px-4'>
            <Col md={12}>
              <Button color='danger' block onClick={enviarAOSEClick}>
                DAR DE BAJA
              </Button>
            </Col>
          </Row>
        </>
      )}
    </>
  )
}

export default ComprobantesElectronicosTab
